'use client'

import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { atom, useRecoilState } from 'recoil'

export const debutSliderState = atom({
  key: 'debutSlider',
  default: 0,
})

export default function InViewDebutLogic({ fadeSpeed, rootMargin }: { fadeSpeed: number; rootMargin: string }) {
  const [inViewed, setInViewed] = useState(false)
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin,
    triggerOnce: true,
  })

  const [selectIndex, setSelectIndex] = useRecoilState(debutSliderState)

  useEffect(() => {
    if (inView) {
      setInViewed(true)
    }
  }, [inView])

  useEffect(() => {
    if (!inViewed) {
      return () => {}
    }

    const timeout = setTimeout(
      () => {
        setSelectIndex((selectIndex) => (selectIndex + 1) % 2)
      },
      1000 * 4 + fadeSpeed
    )
    return () => clearTimeout(timeout)
  }, [inViewed, selectIndex])

  return <div ref={ref}></div>
}
